export const API_ROUTES = {
  AUTHEN: {
    LOG_IN: "/login/cms",
    REGISTER: "/register",
    LOG_OUT: "/logout",
    FORGOT: "/forgot-password",
    VERIFY: "/verify-code",
    RESET: "/reset-password",
    REFRESH_TOKEN: "/refresh/cms",
  },
  TICKET: {
    GET_ALL: "/admin/ticket/u",
    GET_BY_ID: "/user/ticket",
    CREATE: "/user/ticket/create",
    UPDATE: "/user/ticket",
    DELETE: "/user/ticket",
    RESPONSE: "/admin/ticket/reply",
  },
  SERVICE: {
    GET_ALL: "/admin/service",
    GET_BY_ID: "/user/service",
    CREATE: "/admin/service",
    UPDATE: "/admin/service",
    DELETE: "/admin/service",
    GET_ALL_BY_CUSTOMERID: "/admin/service/u",
    GET_VAT_CONFIG: "/admin/vat-config",
    UPDATE_VAT_CONFIG: "/admin/vat-config",
  },
  LIST_SERVICE: {
    GET_ALL: "/admin/service",
    GET_SERVICE_BI_ID: "/admin/service",
    GET_ALL_CATEGORY: "/admin/category",
    GET_SERVICE_BY_CATEGORY_ID: "/admin/category",
  },
  PROFILE: {
    GET_ALL_PROFILE: "/admin/profile/list",
    GET_ALL_ORIGINAL_PROFILE: "/admin/profile/list/original",
    GET_BY_ID: "/admin/profile",
    CREATE: "/admin/profile/",
    UPDATE: "/admin/profile/u",
    DELETE: "/admin/profile/l",
    GET_DETAIL: "/admin/profile",
    UPDATE_GENERAL_PROFILE: "/admin/profile/u",
    DUPLICATE_PROFILE: "/admin/profile/duplicate",
    GET_EDIT_HISTORY: "/admin/profile/",
    GET_LIST_REQUEST_PROFILE: "/admin/profile/list-request",
    GET_PROFILE_ESTIMATE: "/admin/profile/:profileId/estimate",
    UPDATE_PROFILE_ESTIMATE: "/admin/estimate/:profileId/adjustment",
    GET_REQUEST_PROFILE_PENDING: "/admin/profile/list-request/pending",
    GET_ESTIMATE_ADJUSTMENT_HISTORY:
      "/admin/estimate/:profileId/adjustment-history",
    GET_PENDING_ADJUSTMENT: "/admin/estimate/:estimateId/adjustment-pending",
    UPDATE_PENDING_ADJUSTMENT: "/admin/estimate/:estimateId/adjustment-pending",
    DELETE_PENDING_ADJUSTMENT:
      "/admin/estimate/:estimateId/adjustment-pending/:adjustmentId",
    DELETE_ADJUSTMENT_HISTORY:
      "/admin/estimate/:estimateId/adjustment-history/:adjustmentId",
  },
  CATEGORY: {
    GET_ALL: "/admin/category",
    GET_BY_ID: "/admin/category",
    CREATE: "/admin/category",
    UPDATE: "/admin/category",
    DELETE: "/admin/category",
  },
  ACCOUNT: {
    GET_INFO: "user/me/cms",
    UPDATE: "user/me/cms",
  },
  ADMIN: {
    GET_ALL_STAFF: "/admin/staff",
    GET_STAFF_BY_ID: "/admin/staff",
    UPDATE_INFO_STAFF: "/admin/staff",
    DELETE_STAFF: "/admin/staff",
    CREATE_STAFF: "/admin/staff",
    GET_STAFF_PERMISSION: "/admin/staff/:staffId/permissions",
    ASSIGN_PERMISSION: "/admin/staff/:staffId/assign",
  },
  PROCEDUCE: {
    GET: "/admin/procedure",
    GET_BY_ID: "/admin/procedure",
    CREATE: "/admin/procedure",
    UPDATE: "/admin/procedure",
    DELETE: "/admin/procedure",
  },
  POSTS: {
    GET: "/admin/posts",
    GET_BY_ID: "/admin/posts",
    CREATE: "/admin/posts",
    UPDATE: "/admin/posts",
    DELETE: "/admin/posts",
  },
  PROCESS: {
    CREATE: "/admin/profile",
    UPDATE: "/admin/profile",
    DELETE: "/admin/profile",
  },
  DOCUMENT: {
    GET: "/admin/documents",
    GET_BY_ID: "/admin/documents",
    CREATE: "/admin/documents",
    UPDATE: "/admin/documents",
    DELETE: "/admin/documents",
  },
  CUSTOMER: {
    GET_ALL: "/admin/customers/list",
    GET_BY_ID: "/admin/customer",
    UPDATE: "/admin/customer",
    DELETE: "/admin/customer",
    CREATE: "/admin/customer",
    SEARCH_LIST: "admin/customers/list-search",
    GET_ADMIN_CUSTOMERS_SHORT: "/admin/customers/short",
  },
  FORM: {
    ADD_NEW: "/admin/profile",
  },
  CONTRACT: {
    GET_BY_CUSTOMER_ID: "/admin/contract/u",
    GET_BY_ID: "/admin/contract",
    UPDATE: "/admin/contract",
    CREATE: "/admin/contract",
    DELETE: "/admin/contract",
    REQUEST_PROFILE: "/admin/profile",
  },
  BANNER: {
    GET_BANNER: "/admin/news",
    GET_BY_ID: "/admin/news",
    CREATE: "/admin/news",
    UPDATE: "/admin/news",
    DELETE: "/admin/news",
    APPLY: "/admin/news/mobile/apply",
  },
  DEPARTMENT: {
    GET_LIST_DEPARTMENT: "/admin/department/all",
    GET_DETAIL_DEPARTMENT: "/admin/department/:departmentId",
    UPDATE_DEPARTMENT: "/admin/department/:departmentId",
    CREATE_DEPARTMENT: "/admin/department",
    GET_LIST_DEPARTMENT_SHORT: "/admin/department/short",
    DELETE_DEPARTMENT: "/admin/department/:departmentId",
  },
  EMPLOYEE: {
    GET_LIST_EMPLOYEES_OF_DEPARTMENT: "/admin/department/:departmentId/staffs",
    CREATE_EMPLOYEE: "/admin/staff",
    GET_DETAIL_EMPLOYEE: "/admin/staff/:employeeId",
    UPDATE_EMPLOYEE: "/admin/staff/:employeeId",
    GET_LIST_STAFF_SHORT: "/admin/staff/short",
  },
  ROLE: {
    GET_LIST: "/admin/role",
  },
  PERMISSIONS: {
    GET_ME_PERMISSION: "/me/permission",
  },
  FIREBASE: {
    UPLOAD_FILE: "/firebase/upload-image",
    DELETE_FILE: "/firebase/delete-image",
  },
  NOTI: {
    GET_LIST_NOTIS: "/admin/noti-cms",
    GET_NOTIS_COUNT: "/admin/noti-cms/count",
    GET_NOTI_BY_ID: "/admin/noti-cms",
  },
  ORDER: {
    GET_LIST_ORDER: "/admin/order",
    GET_DETAIL_ORDER: "/admin/order/:orderId",
    UPDATE: "/admin/order/:orderId",
  },
  REPORT: {
    GET_REPORT_SERVICE: "/admin/report-cms/service",
    GET_REPORT_PROFILE: "/admin/report-cms/profile",
    GET_REPORT_FINANCE: "/admin/report-cms/finance",
    GET_REPORT_ORIGINAL_PROFILE: "/admin/report-cms/profile/original",
    GET_REPORT_SERVICE_OF_CUSTOMER: "/admin/report-cms/service/:customerId",
    GET_REPORT_PROFILE_OF_CUSTOMER: "/admin/report-cms/profile/:customerId",
    GET_REPORT_FINANCE_OF_CUSTOMER: "/admin/report-cms/finance/:customerId",
    EXPORT_PDF: "/pdf/cms/export-pdf",
    EXPORT_ORIGINAL_PROFILE_PDF: "/pdf/cms/original-profile/export-pdf",
  },
};
